import OwLabel from "@components/shared/OwLabel/OwLabel";
import IFastbound_Disposition from "@models/IFastbound_Disposition";
import { useAppContextNonNull } from "@contexts/AppContext";
import { DispositionDetailModal } from "./DispositionDetailModal";
import React, { useMemo, useCallback } from "react";
import IOrder from "@models/IOrder";

type Props = {
    order: IOrder;
};

export const OrderEntryFastboundPanel = (props: Props) => {
    const { uiContext } = useAppContextNonNull();

    const fastboundDispositions = useMemo(() => props.order.Fastbound_Dispositions || [], [props.order.Fastbound_Dispositions]);

    const closeModal = useCallback(() => {
        uiContext.showModal(false);
    }, [uiContext]);

    const handleDispositionClick = useCallback(
        (disposition: IFastbound_Disposition) => {
            if (!disposition.response_json) {
                return;
            }

            uiContext.setModalComponent(<DispositionDetailModal closeModalFn={closeModal} responseJson={disposition.response_json} />);
            uiContext.showModal(true);
        },
        [uiContext, closeModal]
    );

    return (
        <div className={"OrderEntryFastboundPanel p-2"}>
            {!fastboundDispositions.length && (
                <div className="text-center py-3">
                    <OwLabel leftIconClass="fas fa-book" title="no_fastbound_dispositions" />
                </div>
            )}
            {fastboundDispositions.map((disposition: IFastbound_Disposition) => (
                <div
                    key={disposition.id}
                    onClick={() => handleDispositionClick(disposition)}
                    style={{ cursor: disposition.response_json ? "pointer" : "default" }}
                    className="disposition-row">
                    <div className="d-flex gap-2 text-primary">
                        <i className="fas fa-magnifying-glass" />
                        <h6 className="text-underline cursor-pointer">
                            {disposition.disposition_type} - {disposition.disposition_date} - {disposition.request_type} -{" "}
                            {disposition.item_count} <OwLabel isUnderline={true} title="items" />
                        </h6>
                    </div>
                </div>
            ))}
        </div>
    );
};
